import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ListsContext = createContext(null);

export function ListsProvider({ children }) {
  const { user } = useAuth();
  const [lists, setLists] = useState({});
  const [customers, setCustomers] = useState([]);

  const refreshLists = useCallback(async () => {
    try {
      const { data } = await api.get("/setup/lists");
      setLists(data || {});
    } catch { /* noop */ }
  }, []);

  const refreshCustomers = useCallback(async () => {
    try {
      const { data } = await api.get("/customers");
      setCustomers(data || []);
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    if (user && typeof user === "object") {
      refreshLists();
      refreshCustomers();
    }
  }, [user, refreshLists, refreshCustomers]);

  return (
    <ListsContext.Provider value={{ lists, customers, refreshLists, refreshCustomers }}>
      {children}
    </ListsContext.Provider>
  );
}

export const useLists = () => useContext(ListsContext);
